import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import OpenAppSheetMini from '../components/OpenAppSheetMini';
import UnauthBackground from '../components/layout/UnauthBackground';

function UnauthLayout({ children }: PropsWithChildren) {
  return (
    <div className="w-full min-h-full absolute">
      <div className="fixed inset-0 -z-10">
        <UnauthBackground />
      </div>
      <Outlet />
      <OpenAppSheetMini />
    </div>
  );
}

export default UnauthLayout;
